import {AfterViewInit, Component, Input, OnInit, ViewChild} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import {DecimalPipe} from '@angular/common';
import {StatusChangeLine} from '../../../domain/alerts/status-change-line.model';

@Component({
  selector: 'cm-ad-unit-status-change-table',
  template: `
    <mat-table #table [dataSource]="dataSource"
               matSort matSortActive="adUnitName"
               matSortDirection="asc"
               class="cm-table-content">
      <ng-container *ngFor="let column of columns" [matColumnDef]="column.key">
        <mat-header-cell mat-sort-header *matHeaderCellDef>{{ column.header }}</mat-header-cell>
        <mat-cell *matCellDef="let row">{{ column.cell(row) }}</mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="visibleColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: visibleColumns"></mat-row>
    </mat-table>
  `,
  styles: [`
    .mat-column-days {
      flex: 0 0 50px;
      text-align: right;
    }
  `]
})
export class AdUnitStatusChangeTableComponent implements AfterViewInit, OnInit {

  @Input() paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  @Input()
  loading = false;

  @Input('data')
  set data(data: StatusChangeLine[]) {
    this.dataSource.data = data;
  }

  dataSource = new MatTableDataSource<StatusChangeLine>();

  columns = [
    {key: 'publisher', header: 'Publisher', cell: (row: StatusChangeLine) => `${row.publisher}`},
    {key: 'adUnit', header: 'Ad unit name', cell: (row: StatusChangeLine) => `${row.adUnit}`},
    {key: 'days', header: 'Days', cell: (row: StatusChangeLine) => `${row.days}`},
    {key: 'statusChange', header: 'Status change', cell: (row: StatusChangeLine) => `${row.statusChange}`},
  ];

  @Input()
  visibleColumns = [];

  constructor(private numberPipe: DecimalPipe) {
  }

  getColumns() {
    return this.columns;
  }

  ngOnInit(): void {
    if (!this.visibleColumns || !this.visibleColumns.length) {
      this.visibleColumns = this.columns.map(c => c.key);
    }
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
}

